/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import { ReactComponent as CommonFileSvg } from 'assets/icons/files/Common.svg';
import { ReactComponent as CommonNewFileSvg } from 'assets/icons/files/Common_New.svg';
import { ReactComponent as LampIcon } from 'assets/icons/New/lamp-icon.svg';
import { ReactComponent as TrashSvg } from 'assets/icons/New/Trash.svg';
import classes from './Document.module.scss';

/**
 * Document structure
 * id: string,
 * name: string,
 * file: File Obj
 */
const Document = ({ className, addEl, title, caption, onDelete, documents, isNew, disabled }) => {
  const tDocuments = documents || [];
  const hasDocuments = tDocuments.length > 0;
  return (
    <div
      className={cn(
        classes.wrapper,
        {
          [classes.disabled]: disabled,
        },
        className
      )}>
      <div className={classes.header}>
        <span>{title}</span>
      </div>
      {!!caption && (
        <div className={classes.caption}>
          <span>
            <LampIcon />
          </span>
          <span>{caption}</span>
        </div>
      )}
      {hasDocuments && (
        <div className={classes.documents}>
          <ul>
            {documents.map((document) => {
              const { name, id } = document;
              return (
                <li key={id}>
                  <span>
                    {isNew ? <CommonNewFileSvg /> : <CommonFileSvg />}
                    <span>{name}</span>
                  </span>
                  {disabled ? (
                    <span />
                  ) : (
                    <span
                      onClick={() => {
                        if (onDelete) onDelete(document);
                      }}>
                      <TrashSvg />
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className={cn(classes.addEl)}>{addEl}</div>
    </div>
  );
};

export default Document;
